// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 65 ? "initial" : chunkId) + "." + {"65":"71618154","209":"44562529","268":"975e633a","404":"e587efa6","467":"5e0e6f75","699":"2d2096cd"}[chunkId] + ".chunk.js";
};